import { createClient } from 'react-fetching-library';

import { requestHostInterceptor } from './requestInterceptors';
import { responseInterceptor } from './responseIntercreptors';

// In real application this const will be stored in ENV's

export const Client = createClient({
  requestInterceptors: [requestHostInterceptor()],
  responseInterceptors: [responseInterceptor()]
});
